import React from 'react'
import { IconProps } from './types'
import { Flex } from '@chakra-ui/core'
import { Video } from 'lucide-react'

const VideoIcon: React.FC<IconProps> = ({
  iconWidth = 24,
  iconHeight = 24,
  width = '40px',
  height = '40px',
  iconColor = '#F77D60',
  bgColor = '#FCD7D2',
  ...props
}) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      bg={bgColor}
      width={width}
      height={height}
      borderRadius="full"
      {...props}
    >
      <Video width={iconWidth} height={iconHeight} color={iconColor} strokeWidth={2} />
    </Flex>
  )
}

export default VideoIcon
